module.exports = __webpack_public_path__ + "img/menoume.c1932358.png";